module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-white@3x-9cc1328f.svg";